import { api } from "@";
import { sendMultiSMSPayload } from "./helpers";

// send message to multiple users
export const sendMultiSMS = async (data) => {
  await api.post("/api/AdminSms/group-message", sendMultiSMSPayload(data));
};
